import { cn } from "@/lib/utils";

export default function OfferValidUntil({
  validUntil,
  className,
}: {
  validUntil: string | null;
  className?: string;
}) {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString("de-DE");
  };

  if (!validUntil) return null;
  return (
    <div className={cn(className)}>
      Gültig bis <span>{formatDate(validUntil)}</span>
    </div>
  );
}
